import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'
import React, { PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'
import { rem } from '../../../utils'
import { FlexibleContentRow } from '../flexibleContentRow'
import { SpacerFragment } from '@gql'

export type SpacerProps = SpacerFragment

type SpacerSizes = 'small' | 'large'

const margins: Record<SpacerSizes, Partial<Record<Breakpoint, number>>> = {
  small: {
    xs: 75,
  },
  large: {
    xs: 75,
    sm: 140,
  },
}

export const spacerCss = (size: SpacerSizes, { top = true, bottom = true } = {}) => css`
    ${Object.keys(margins[size]).map((key: Breakpoint) => css`
        ${props => props.theme.breakpoints.up(key)} {
            ${top && css`
                margin-block-start: ${props =>rem((margins[size][key] || 0) / 2, props.theme)};
            `}
            ${bottom && css`
                margin-block-end: ${props =>rem((margins[size][key] || 0) / 2, props.theme)};
            `}
        }
    `)}
`

export const SpacerRow = styled(FlexibleContentRow)<{ $size: SpacerSizes }>`
  && {
    ${props => spacerCss(props.$size)}
  }
`

export const Spacer: React.FC<PropsWithChildren<SpacerProps>> = ({ size: large, showHr }) => {
  return (
    <SpacerRow $size={large ? 'large' : 'small'}>
      {showHr && <hr />}
    </SpacerRow>
  )
}
